<template>
   <div>
     <main-page-component v-if="$ls.get('token') != null"></main-page-component>
     <login-view-component v-if="$ls.get('token') == null"></login-view-component>
   </div>
</template>

<script>
import MainPageComponent from '@/components/pages/MainPageComponent'
import LoginViewComponent from '@/components/pages/PageLoginComponent'
// import {JL} from '@/utils/Logger'
import webservices from '@/utils/webservice'

export default {
  name: 'App',
  components: {LoginViewComponent, MainPageComponent},
  data () {
    return {
      authenticatedThrowZopim: false,
      updateCheckInterval: null
    }
  },
  mounted () {
    if (!this.authenticatedThrowZopim && this.$store.state.app.session.hasOwnProperty('username')) {
      this.authenticatedThrowZopim = true
      let username = this.$store.state.app.session.username
      if (window.hasOwnProperty('$zopim')) {
        window.$zopim(() => {
          window.$zopim.livechat.setName(username.split('@')[0])
          window.$zopim.livechat.setEmail(username)
        })
      }
      // JL.setOptions({
      //   requestId: username
      // })
    }

    this.updateCheckInterval = setInterval(async () => {
      let lastVersion = await webservices.fixtures.getLastVersion()

      if (lastVersion !== null && lastVersion.hasOwnProperty('build')) {
        if (lastVersion.build > process.env.BUILD) {
          if (this.$route.path === '/cars/search' || this.$route.path === '/promotions') {
            window.location.reload(true)
          }
        }
      }
    }, 60000)
  },
  beforeDestroy () {
    clearInterval(this.updateCheckInterval)
  }
}
</script>

<style lang="scss" scoped>

</style>



// WEBPACK FOOTER //
// src/App.vue